import { api } from '../../config/base-api';

export type OfferAvailabilityStatus =
  | 'AVAILABLE'
  | 'EXPIRED'
  /** FIN-8011 (decisão 14): a data de início de venda ainda não chegou. */
  | 'NOT_STARTED'
  /** FIN-8119 (D05): produto esgotado; tem prioridade sobre as datas. */
  | 'SOLD_OUT';

/**
 * FIN-8016 (C3): disponibilidade da oferta calculada pelo BFF a partir das
 * datas de venda da oferta.
 */
/**
 * FIN-8239: vagas do produto, calculadas pelo BFF. Só exibição. O BFF não
 * expõe `salesLimit` nem `soldCount` (FIN-8119 DS-02).
 */
export interface OfferProductSales {
  /** null = sem contagem disponível; <= 0 = esgotado (não exibe). */
  remainingSlots: number | null;
  /** Mostra as vagas só com até N restantes; null = sempre, 0 = nunca. */
  urgencySalesThreshold: number | null;
}

export interface OfferPlanAvailability {
  id: string;
  availability: OfferAvailabilityStatus;
  /** ISO 8601 em UTC; null = oferta sem data limite. */
  availableUntil: string | null;
  /** FIN-8011 (decisão 14): ISO 8601 em UTC; null = oferta sem data de início. */
  availableFrom?: string | null;
  /**
   * FIN-8011 (D17): minutos antes do fim das vendas para mostrar o contador;
   * null = mostra o tempo todo. Opcional: BFF antigo não manda.
   */
  urgencyTimeThresholdMinutes?: number | null;
  /**
   * FIN-8268: dias corridos (Brasília) antes de `availableUntil` em que o
   * boleto deixa de ser oferecido; null/ausente = sem trava.
   */
  boletoCutoffDays?: number | null;
}

export interface GetProductDataByPlanIdResponse {
  id: string;
  code: string;
  business?: string;
  /** Opcional: BFF sem FIN-8011 não manda (deploy fora de ordem). */
  plan?: OfferPlanAvailability;
  /** FIN-8239: limite de vendas do produto, na raiz; null = sem limite. */
  productSales?: OfferProductSales | null;
}

export async function getProductDataByPlanId(
  planId: string,
  isServer: boolean
): Promise<GetProductDataByPlanIdResponse> {
  const requestUrl = isServer
    ? `http://localhost:3000/api/v1/plan/${planId}/product`
    : `/api/v1/plan/${planId}/product`;

  const res = await api.get<GetProductDataByPlanIdResponse>(requestUrl);

  return res.data;
}
